<script>
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'
    import keyBy from '@fno/lib/key-by.js'
    import schema from 'fanx-schema/resource/taskTabTool'
    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
    import { currentSchool } from '@fno/service/api/schools.js'

    export let context
    export let saving
    export let asr
    export let schoolId

    const { stepIdToRoute, tier } = $currentSchool

    // Filter stepIdToStep to only include keys that exist in stepIdToRoute
    const stepIdToStep = keyBy(schema.properties.steps.fragments, 'id')
    const filteredStepIdToStep = Object.keys(stepIdToStep)
        .filter((key) => key in stepIdToRoute)
        .reduce((acc, key) => {
            acc[key] = stepIdToStep[key]
            return acc
        }, {})

    const ignoreStepsForTier2 = [
        "AFFILIATIONS",
        "APP_COLORS",
        "FEATURES"
    ]

    $: incompleteSteps = Object.values(context.form.clientOnboarding.attributes.steps)
        .filter((step) => tier === 'tier2' && !ignoreStepsForTier2.includes(step.id))
        .filter((step) => step.status !== 'COMPLETED')
</script>

<div class="d-flex justify-content-center mb-5">
    <img style="height: 150px" alt="You are done!" src="{staticAssetPrefix}img/onboarding/finish-graphic.png" />
</div>

{#if !incompleteSteps || !incompleteSteps.length}
    <p>
        Thank you for taking the first steps in configuring your app! Please make sure all of the steps are completed
        with the requested information before you Save and Complete.
    </p>
    <p>
        Upon Saving and Completing the T.A.B. you will be redirected to your Portal.
    </p>
{:else}
    <p>You are almost done! Only a few more pages to go check and mark as completed:</p>
    <ul>
        {#each incompleteSteps as step}
            {#if filteredStepIdToStep[step.id]}
                <li>
                    <a href={asr.makePath(stepIdToRoute[step.id], { schoolId })}>
                        {filteredStepIdToStep[step.id].label}
                    </a>
                </li>
            {/if}
        {/each}
    </ul>
{/if}

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons
    lastPage
    disableNext={incompleteSteps.length}
    {context}
    {saving}
    on:save
    on:nextStepClicked
    on:previousStepClicked
/>
